<template>
  <div class="container-footer">
    <div class="box-footer">
        <div class="box-nav">
            <div class="box-contactus">
                <div class="item-logo">
                    <router-link :to="pathStr.home">
                        <img :src="imgUrl" alt="LOGO">
                    </router-link>
                    <p>CONTACT US</p>
                </div>
                <div class="item-link">
                    <p><span style="color: #ba0c2f;">Support:</span> support@meshare.com</p>
                    <p><span style="color: #ba0c2f;">Media:</span> media@meshare.com</p>
                    <p><span style="color: #ba0c2f;">Business:</span> partnerships@meshare.com</p>
                    <p style="padding-right: 10px;">1401 Interstate Drive, STE A, Champaign, IL 61822</p>
                </div>
            </div>
            <div class="list-link">
                <div v-for="(val,index) in linkData" :key="index">
                    <v-linklist :linkData="val"></v-linklist>
                </div>
            </div>
        </div>
        <div class="lan-switch-box">
          <v-slist></v-slist>
          <div class="lan-box">
            <a href="https://www.meshare.cn">CN</a> <span></span> <a>EN</a>
          </div>
        </div>
        <div class="box-copyright">
            <p>© {{year}} meShare Inc. </p>
        </div>
    </div>
  </div>
</template>

<script>
import LinkList from '@/modules/footer/linkList.vue'
import SocialList from '@/modules/footer/social-list.vue'
import {WOW} from 'wowjs'
export default {
  name: 'Footer',
  components:{
      'v-linklist': LinkList,
      'v-slist': SocialList,
  },
  data () {
    return {
      imgUrl: '/static/images/common/meshare-red.png',
      linkData: [
        {
          title: "PRODUCTS",
          children: [
              {name: "IoT Platform", path: "/iot-platform", sname: "IoT Platform"},
              {name: "HD Video Streaming & <br>Cloud Recording", path: "/cloud-video-recording-streaming", sname:"HD Video Streaming & Cloud Recording"},
              {name: "Web & Mobile App", path: "/web-and-mobile-app", sname: "Web & Mobile App"},
              {name: "meShare Analytics & <br>Growth", path: "/analytics-and-growth", sname: "meShare Analytics & Growth"},
              {name: "Services", path: "/services", sname: "Services"},
          ]
        },
        {
          title: "SOLUTIONS",
          children: [
              {name: "Smart Home & IoT", path: "/smart-home-and-iot", sname: "Smart Home & IoT"},
              {name: "Security & Surveillance", path: "/security-and-surveillance", sname: "Security & Surveillance"},
              {name: "Property Management", path: "/property-management-and-real-estate", sname: "Property Management"},
          ]
        },
        {
          title: "POLICIES",
          children: [
              {name: "Terms of Services", path: "/terms-of-services", sname: "Terms of Services"},
              {name: "Privacy Notice", path: "/privacy-notice", sname: "Privacy Notice"},
          ]
        },
        {
          title: "COMPANY",
          children: [
              {name: "Why meShare", path: "/why", sname: "Why meShare"},
              {name: "Blog", path: "/press", sname: "Blog"},
              {name: "Careers", path: "/career", sname: "Careers"},
          ]
        }
      ],
      year: '',
      pathStr:{
        home: '/',
      }
    }
  },
  created() {
    let lan = this.getParameters('lan');
    if(lan != ''){
      this.$cookie.set('x-language', lan, { expires: 7 });
      this.$cookie.set('x-page-name', window.location.pathname, { expires: 7 });
    }
  },
  mounted(){
    new WOW().init();
    this.year = (new Date()).getFullYear();


    let menuData = [...(this.linkData)];
    let lan = this.$cookie.get('x-language');
    if(lan == 'en-us' || lan == 'en-us/'){
      this.pathStr.home = '/?lan=en-us';

      this.linkData = menuData;
    }
  },
  methods:{
    /*
    * 获取URL 传递的参数
    * ky: 参数
    * return: String
    * */
    getParameters(ky){
      let url = window.location.search;
      let theRequest = new Object();
      if (url.indexOf("?") != -1) {
        let str = url.substr(1);
        let strs = str.split("&");
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1]);
        }
      }

      return theRequest[ky] == undefined ? '' : theRequest[ky];
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';
.container-footer{
    background: #ffffff;
    .box-footer{
        width: 96%;
        max-width: 1100px;
        margin: 0 auto;
        padding: 60px 0;
        @media screen and (max-width: $media-max-width) {
            padding: 30px 0 0;
            width: 85%;
        }
        .box-nav{
            display: -webkit-flex;
            display: flex;
            justify-content: space-between;
            @media screen and (max-width: $media-max-width) {
                flex-direction: column;
            }
            .box-contactus{
                width: 270px;
                display: -webkit-flex;
                display: flex;
                justify-content: flex-start;
                flex-direction: column;
                @media screen and (max-width: $media-max-width) {
                    width: 100%;
                    margin-bottom: 10px;
                }
                .item-logo{
                    img{
                        width: 131px;
                        margin-bottom: 20px;
                    }
                    p{
                        color: #ba0c2f;
                        font-size: 14px;
                        font-family: 'GothamMedium';
                        letter-spacing: 1px;
                    }
                }
                .item-link{
                    display: -webkit-flex;
                    display: flex;
                    flex-direction: column;
                    @media screen and (max-width: $media-max-width) {
                        padding-bottom: 10px;
                        border-bottom: 1px solid #e0e0e0;
                    }
                    p{
                        font-size: 14px;
                        font-family: 'GothamBook';
                        color: #000000;
                        margin: 4px 0;
                    }
                }
            }
            .list-link{
                width: calc(100% - 320px);
                display: -webkit-flex;
                display: flex;
                justify-content: space-between;
                flex-direction: row;
                @media screen and (max-width: 1400px) {
                    width: calc(100% - 280px);
                }
                @media screen and (max-width: 1024px) {
                    width: calc(100% - 250px);
                }
                @media screen and (max-width: $media-max-width) {
                    flex-direction: column;
                    width: 100%;
                }
            }
        }
        .box-copyright{
            padding: 10px 0 20px;
            @media screen and (max-width: $media-max-width) {
                padding: 10px 0 10px;
            }
            p{
                font-size: 13px;
                font-family: 'GothamLight';
                color: #424242;
            }
        }
    }
  .lan-switch-box{
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    .lan-box{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 65px;
      a{
        color: #1b1c1d;
        cursor: pointer;
      }
      span{
        display: block;
        background-color: #1b1c1d;
        width: 1px;
        height: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/footer/index.vue